import { render, staticRenderFns } from "./income-data.vue?vue&type=template&id=b37b3fe6&scoped=true&"
import script from "./income-data.vue?vue&type=script&lang=ts&"
export * from "./income-data.vue?vue&type=script&lang=ts&"
import style0 from "./income-data.vue?vue&type=style&index=0&id=b37b3fe6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37b3fe6",
  null
  
)

export default component.exports